import { Stack, Typography } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { AIStyledText } from 'components/AI/AIStyles';

export const AITagManagementTitle = () => (
  <Stack
    direction="row"
    gap={1}
    alignItems="center"
    className="form-group form-inline-label"
    sx={{ marginBottom: '0' }}
  >
    <Typography component="label" sx={{ cursor: 'pointer' }}>
      Manage Tags
    </Typography>
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={{ color: '#00afcc' }}
    >
      <AutoAwesome sx={{ width: '14px', height: '14px' }} />
      <AIStyledText>AI</AIStyledText>
    </Stack>
  </Stack>
);
